import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { hearingNoticeApi } from '../../utilities/api';
import { HearingNotice } from '../../utilities/interfaces/HearingNotice';
import { hearingNoticeCommentApi } from '../../utilities/api/hearingNoticeCommentApi';

interface hearingNoticeState {
    hearingNotices: HearingNotice[];
    creatingHearingNotice: boolean;
};

const initialState: hearingNoticeState = {
    hearingNotices: [],
    creatingHearingNotice: false,
};

const hearingNoticeSlice = createSlice({
    name: 'hearingNotice',
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(getByFilingId.pending, (state, action: any) => {
            state.hearingNotices = [];
        });

        builder.addCase(getByFilingId.fulfilled, (state, action: any) => {
            state.hearingNotices = action.payload;
        });

        builder.addCase(createHearingNotice.pending, (state) => {
            state.creatingHearingNotice = true;
        });
        builder.addCase(createHearingNotice.fulfilled, (state, action: any) => {
            state.hearingNotices.push(action.payload);
            state.creatingHearingNotice = false;
        });
        builder.addCase(createHearingNotice.rejected, (state) => {
            state.creatingHearingNotice = false;
        });
    }
});

export const getByFilingId = createAsyncThunk('hearingNotice/getByFilingId', async (filingId: number) => {
    const response: any = await hearingNoticeApi.getByFilingId(filingId);
    for (let notice of response) {
        notice.comments = await hearingNoticeCommentApi.getByHearingNoticeId(notice.id);
    }
    return response;
});

export const createHearingNotice = createAsyncThunk('hearingNotice/createHearingNotice', async (hearingNotice: any) => {
    const response = await hearingNoticeApi.create(hearingNotice);
    return response;
});

export default hearingNoticeSlice.reducer;